// *********************************
// Code generated by sdkgen - edited by you!
//
// This module contains any hand-written services or other things your module
// needs to share with applications that use it.
// *********************************
import { NgModule } from '@angular/core';
import { WspAdminCenterInternalModule } from './_internal/wsp-admin-center.module';

@NgModule({
  imports: [WspAdminCenterInternalModule],
})
export class WspAdminCenterModule {}
